import React, { FC } from 'react'

import { IconCommentsProps } from './IconComments.types'
import * as Styled from './styles/IconComments.style'

import { nonThemeableRules } from '../../ruleSet'

const IconComments: FC<IconCommentsProps> = ({
  size = nonThemeableRules.defaultSize as number as IconCommentsProps['size'],
  isResponsive = false,
}: IconCommentsProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M33.629 17.738H10.367m23.262 5.372H10.367m23.262 5.367H10.367'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path d='M17.523 33.844 10.367 41v-7.156' stroke='#fff' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path
          d='M10.367 33.844H8.578A3.589 3.589 0 0 1 5 30.262V16.059a3.59 3.59 0 0 1 3.57-3.582H39v17.785a3.594 3.594 0 0 1-3.578 3.582H17.523'
          stroke='#fff'
          strokeLinecap='round'
          strokeWidth='2'
        />
        <path
          d='M39.324 30.059A3.694 3.694 0 0 0 43 26.37V8.063H11.684A3.693 3.693 0 0 0 8 11.75v.73'
          stroke='#fff'
          strokeLinecap='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconComments
